<div class="modal-container">
  <div class="modal-header">
    <input ngbAutofocus class="no-size" />
    <span class="modal-title">{{ modalTitle }}</span>
    <grid-ui-icon
      type="button"
      id="dismissButton"
      class="close-icon"
      aria-label="Dismiss"
      (click)="dismiss()"
      data-hook="ask-an-analyst-dismiss-btn"
      ngbTooltip="Close window"
      name="cross"
      data-testid="icon-close-modal"
    ></grid-ui-icon>
  </div>

  <div class="modal-body">
    @if (saveStatus === SavingRequestStatus.saving) {
      <div>
        <grid-ui-loading message="Sending your question, please wait."></grid-ui-loading>
      </div>
    }

    @if (analystInfo !== null) {
      <div class="analyst">
        <div class="photo">
          @if (analystInfo!.photo_thumbnail) {
            <img alt="{{ analystInfo!.name }}" src="{{ analystInfo!.photo_thumbnail!.path }}" data-hook="ask-an-analyst-photo" />
          }
        </div>
        <div class="details">
          <h6 class="name" title="{{ analystInfo!.name }}" data-hook="ask-an-analyst-name">
            {{ analystInfo!.name }}
          </h6>
          @if (analystInfo!.title) {
            <span class="title small" title="{{ analystInfo!.title }}" data-hook="ask-an-analyst-title">
              {{ analystInfo!.title }}
            </span>
          }
          @if (analystInfo !== null) {
            <div class="d-flex contact-links-container" data-hook="ask-an-analyst-contact-links-container">
              @if (analystInfo!.phone) {
                <a href="tel:{{ analystInfo!.phone }}" data-hook="ask-an-analyst-contact-phone-anchor" data-testid="link-phone">
                  <span
                    class="contact-link phone"
                    ngbTooltip="{{ analystInfo!.phone || '' }}"
                    placement="bottom"
                    data-hook="ask-an-analyst-contact-phone"
                  >
                    <svg>
                      <use xlink:href="#shape-phone" />
                    </svg>
                  </span>
                </a>
              }
              @if (analystInfo!.twitter) {
                <a
                  href="{{ analystInfo!.twitter }}"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-hook="ask-an-analyst-contact-twitter-anchor"
                  data-testid="link-twitter"
                >
                  <span
                    class="contact-link twitter"
                    ngbTooltip="{{ analystInfo!.twitter || '' }}"
                    placement="bottom"
                    data-hook="ask-an-analyst-contact-twitter"
                  >
                    <svg>
                      <use xlink:href="#shape-twitter" />
                    </svg>
                  </span>
                </a>
              }
              @if (analystInfo!.linked_in && analystInfo.linked_in !== MAPLECROFT_CORPORATE_LINKED_IN) {
                <a
                  href="{{ analystInfo!.linked_in }}"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-hook="ask-an-analyst-contact-linked-in-anchor"
                  data-testid="link-linkedin"
                >
                  <span
                    class="contact-link linkedin"
                    ngbTooltip="{{ analystInfo!.linked_in || '' }}"
                    placement="bottom"
                    data-hook="ask-an-analyst-contact-linked-in"
                  >
                    <svg>
                      <use xlink:href="#shape-linkedin" />
                    </svg>
                  </span>
                </a>
              }
            </div>
          }
        </div>
      </div>
    }
    @if (saveStatus === SavingRequestStatus.initial) {
      <div>
        <div class="form-group">
          <label for="enter-a-subject">Enter A Subject</label>
          @if (!fixedSubject) {
            <input
              [(ngModel)]="subject"
              class="form-control"
              id="enter-a-subject"
              maxlength="80"
              placeholder="Enter A Subject"
              data-hook="ask-an-analyst-subject-input"
              data-testid="input-enter-a-subject"
            />
          }
          @if (fixedSubject) {
            <div class="ms-2" data-hook="ask-an-analyst-subject-readonly"><strong>Subject:</strong> {{ fixedSubject }}</div>
          }
        </div>
        <div class="form-group">
          <label for="question">{{ questionPlaceholder }}</label>
          <textarea
            [(ngModel)]="question"
            id="question"
            class="form-control question-textarea"
            [placeholder]="questionPlaceholder"
            data-hook="ask-an-analyst-message-textarea"
            data-testid="input-ask-a-question"
          ></textarea>
        </div>
      </div>
    }
    @if (saveStatus === SavingRequestStatus.saved) {
      <div class="thanks" [class.analyst-shown]="analystInfo">
        <h3>Thank You!</h3>
        <span class="small">Your message has been sent.</span>
        @if (analystInfo && analystInfo!.name) {
          <span class="small" data-hook="ask-an-analyst-named-thank-you">
            {{ analystInfo!.name.split(' ')[0] }} will be in touch soon.
          </span>
        }
        @if (analystInfo === null || !analystInfo!.name) {
          <span class="small" data-hook="ask-an-analyst-unnamed-thank-you"> An analyst will be in touch soon. </span>
        }
      </div>
    }
    @if (saveStatus === SavingRequestStatus.error && apiError) {
      <div class="error">
        <h3 data-hook="ask-an-analyst-error-heading">{{ apiError!.title }}. We could not send the message.</h3>
        <span class="small" data-hook="ask-an-analyst-error-message"> {{ apiError!.message }} Please try again. </span>
      </div>
    }
  </div>

  <div class="modal-footer" [class.centered]="saveStatus === SavingRequestStatus.saved || saveStatus === SavingRequestStatus.error">
    @if (saveStatus === SavingRequestStatus.initial) {
      <button type="button" class="btn mc-btn-secondary" (click)="dismiss()" data-hook="ask-an-analyst-cancel-btn" data-testid="btn-cancel">
        Cancel
      </button>
    }
    @if (saveStatus === SavingRequestStatus.initial) {
      <button
        type="submit"
        class="btn mc-btn-primary"
        [disabled]="!(subject.length && question.length)"
        (click)="sendQuestion()"
        data-hook="ask-an-analyst-send-btn"
        data-testid="btn-send"
      >
        Send
      </button>
    }
    @if (saveStatus === SavingRequestStatus.saved) {
      <button type="button" class="btn mc-btn-primary" (click)="close()" data-hook="ask-an-analyst-done-btn" data-testid="btn-done">
        Done
      </button>
    }
    @if (saveStatus === SavingRequestStatus.error) {
      <button
        type="button"
        class="btn mc-btn-primary"
        (click)="clearError()"
        data-hook="ask-an-analyst-accept-btn"
        data-testid="btn-accept"
      >
        Accept
      </button>
    }
  </div>
</div>
